import KeyFiguresRadarChartBox from './KeyFiguresRadarChartBox'

export default KeyFiguresRadarChartBox
